import { useFirestore } from "@/hooks/firestore/core/useFirestore";
import { userVerificationsStatus } from "../models/userVerifications";

export const useVerificationReadiness = () => {
  const { data, error, isLoading } = useFirestore(
    "/users/{userId}/verifications/status",
    userVerificationsStatus,
  );

  return {
    ready: data?.ready ?? false,
    error,
    isLoading,
  } as const;
};
